import { useEffect, useRef, useState } from "react";
import useToggleWidget from "../../store/useToogleWidget";
import "../widget/widget.css";
import data from "../../data/data";
import AccessibilityProfile from "../profile/profile";
import AccessibilityCustomize from "../../common/customize/customize";
import Certification from "../certification/certification";
import useToogleCertification from "../../store/useCertificationStore";
import ResetSuccess from "../../common/resetSuccess/resetSuccess";
import { useDispatch, useSelector } from "react-redux";
import {
  selectIsFeedbackOpen,
  setFeedBackOpened,
} from "../../reduxSlices/feedback";
import {
  getLanguageOfUser,
  getwidgetSize,
  setLanguageOfUser,
  getKeyboardStatus,
  isMobile,
  setKeyboardStatus,
  removeTooltipStatus,
  applyTextSettingsFromStorage,
  getWidgetPosition,
} from "../../store/user";
import {
  selectIsResetOpen,
  toggleReset,
} from "../../reduxSlices/resetToggleSlice";
import Feedback from "../feedback/feedback";
import Language from "../language/language";
import { setKeyboardStatusRedux } from "../../reduxSlices/keyboardSlices";
import DictionaryActiveModal from "../dictionary/dictionaryActiveModal";
import { useTranslation } from "react-i18next";
import { getWidgetSettings } from "../../serivces/widgetService";

interface LanguageItem {
  image?: string;
  url?: string;
  name: string;
  language: string;
  code: string;
}

function Widget() {
  const { toggle } = useToggleWidget();
  const { isCerticationOpen } = useToogleCertification();
  const [isLanguageOpen, setIsLanguageOpen] = useState(false);
  const isFeedbackOpen = useSelector(selectIsFeedbackOpen);
  const [sample] = useState(false);
  const [vh, setVh] = useState(window.innerHeight * 0.01);
  const dispatch = useDispatch();
  const isResetOpen = useSelector(selectIsResetOpen);
  const { t, i18n } = useTranslation() as {
    t: (key: string, defaultValue?: string) => string;
    i18n: { changeLanguage: (lang: string) => void };
  };

  const [widgetColor, setWidgetColor] = useState<any>(
    "linear-gradient(92deg, #009DCC 7.8%, #3B4395 97.1%)",
  );
  const [selectedCategory, setSelectedCategory] = useState<any>();
  const [higlightId, setHiglightId] = useState<any>();
  const [widgetSettings, setWidgetSettings] = useState<any>({});
  const [selectedTab, setSelectedTab] = useState<string>(data.keyTabs[0].title);
  const [isTooltipOpen, setIsTooltipOpen] = useState(false);
  const [language, setLanguage] = useState<LanguageItem | null>(null);

  const keyboardStatus = useSelector(
    (state: any) => state.keyboard.keyboardStatus,
  );
  const moveWidgetRedux = useSelector((state: any) => state.movewidget);
  const buttonRefs = useRef<Array<HTMLButtonElement | null>>([]);

  useEffect(() => {
    const status = getKeyboardStatus();
    if (status) {
      dispatch(setKeyboardStatusRedux(status));
    }
  }, [dispatch]);

  useEffect(() => {
    const updateVh = () => {
      setVh(window.innerHeight * 0.01);
      document.documentElement.style.setProperty(
        "--vh",
        `${window.innerHeight * 0.01}px`,
      );
    };

    updateVh();
    window.addEventListener("resize", updateVh);

    return () => window.removeEventListener("resize", updateVh);
  }, []);

  const handleSelectedTab = (title: string) => {
    setSelectedTab(title);
    setSelectedCategory("");
    setHiglightId("");
  };

  // const handleFooter = (title: string) => {
  //   if (title === data.footerTabs[0].title) {
  //     dispatch(setFeedBackOpened(!isFeedbackOpen));
  //   }

  //   if (title === data.footerTabs[1].title) {
  //     dispatch(toggleReset(true));
  //   }
  // };

  const handleFooter = (title: string) => {
    if (title === data.footerTabs[0].title) {
      window.open(
        "https://www.incluway.de/formulare/kontakt",
        "_blank",
        "noopener,noreferrer",
      );
      return;
    }

    if (title === data.footerTabs[1].title) {
      dispatch(toggleReset(true));
    }
  };

  const handleLanguageSelection = () => {
    setIsLanguageOpen((prev) => !prev);
    setLanguage(getLanguageOfUser());
  };

  useEffect(() => {
    const widgetSize = getwidgetSize();
    document.documentElement.style.fontSize = widgetSize ? "125%" : "100%";

    websiteData();
    applyTextSettingsFromStorage();
    restoreSavedColorSettings();
  }, []);

  const restoreSavedColorSettings = () => {
    const storedColorData = localStorage.getItem("colorSliderValues");
    if (!storedColorData) return;

    try {
      const parsed = JSON.parse(storedColorData);
      const root = document.documentElement;

      if (parsed?.backgroundColor !== undefined) {
        if (parsed.backgroundColor) {
          root.style.setProperty(
            "--incluway-custom-bg-color",
            parsed.backgroundColor,
          );
        } else {
          root.style.removeProperty("--incluway-custom-bg-color");
        }
      }

      if (parsed?.textColor !== undefined) {
        if (parsed.textColor) {
          root.style.setProperty(
            "--incluway-custom-text-color",
            parsed.textColor,
          );
        } else {
          root.style.removeProperty("--incluway-custom-text-color");
        }
      }
    } catch (error) {
      console.error("Failed to restore saved color settings", error);
    }
  };

  const changeLang = async (nextLanguage: any) => {
    i18n.changeLanguage(nextLanguage);
  };

  useEffect(() => {
    setLanguage(getLanguageOfUser());
  }, [isLanguageOpen]);

  const websiteData = async () => {
    const injected = (window as any).__INCLUWAY_BOOTSTRAP__;
    const resp = injected ?? (await getWidgetSettings());
    const settings = resp?.settings ?? resp;

    setWidgetSettings(settings);

    if (settings?.advanced?.profilesEnabled === true) {
      setSelectedTab(data.keyTabs[0].title);
    } else {
      setSelectedTab(data.keyTabs[1].title);
    }

    const storedLanguage = getLanguageOfUser();

    if (storedLanguage?.code) {
      setLanguage(storedLanguage);
      await changeLang(storedLanguage.code);
    } else {
      const defaultLanguage = settings?.advanced?.defaultLanguage;

      let resolvedLanguage = null;

      for (let i = 0; i < data.languageList.length; i++) {
        const item = data.languageList[i];

        if (
          item.language === defaultLanguage ||
          item.name === defaultLanguage ||
          (defaultLanguage === "German" && item.code === "de") ||
          (defaultLanguage === "English" && item.code === "en")
        ) {
          resolvedLanguage = item;
          break;
        }
      }

      if (resolvedLanguage) {
        setLanguageOfUser(resolvedLanguage);
        setLanguage(resolvedLanguage);
        await changeLang(resolvedLanguage.code);
      } else {
        await changeLang("en");
      }
    }

    if (settings?.appearance?.colors?.widget?.gradientEnabled === true) {
      const direction = "92deg";
      const colorValue = `linear-gradient(${direction}, ${settings.appearance.colors.widget.color}, ${settings.appearance.colors.widget.colorGradientEnd})`;
      setWidgetColor(colorValue);
    } else {
      setWidgetColor(settings?.appearance?.colors?.widget?.color);
    }
  };

  const extractColors = (gradient: any) => {
    if (typeof gradient !== "string") {
      return { firstColor: "#000000", secondColor: "#000000" };
    }

    const matches = gradient.match(/#(?:[0-9a-fA-F]{3}){1,2}/g);
    const [firstColor, secondColor] = matches || ["#000000", "#000000"];
    return { firstColor, secondColor };
  };

  const { secondColor } = extractColors(widgetColor);

  useEffect(() => {
    if (widgetColor) {
      document.documentElement.style.setProperty("--scrollbar-track", "#fff");
      document.documentElement.style.setProperty(
        "--scrollbar-thumb",
        secondColor,
      );
    }
  }, [widgetColor, secondColor]);

  useEffect(() => {
    if (isResetOpen) {
      setKeyboardStatus(false);
      dispatch(setKeyboardStatusRedux(false));
      removeTooltipStatus();
    }
  }, [isResetOpen, dispatch]);

  const resolveHorizontalAnchor = () => {
    const storedPosition = getWidgetPosition();

    if (storedPosition === "left" || storedPosition === "right") {
      return storedPosition;
    }

    const movedPosition = moveWidgetRedux?.moveWidget;
    if (movedPosition === "left" || movedPosition === "right") {
      return movedPosition;
    }

    const settingsPosition =
      widgetSettings?.position?.positionOpen?.desktop?.horizontalAnchor;

    if (settingsPosition === "left" || settingsPosition === "right") {
      return settingsPosition;
    }

    return "right";
  };

  const resolvedHorizontalAnchor = resolveHorizontalAnchor();

  const resolvedVerticalAnchor =
    widgetSettings?.position?.positionOpen?.desktop?.verticalAnchor === "top"
      ? "top"
      : "bottom";

  const horizontalDistance =
    widgetSettings?.position?.positionOpen?.desktop?.horizontalDistance ??
    "20px";

  const verticalDistance =
    widgetSettings?.position?.positionOpen?.desktop?.verticalDistance ?? "20px";

  const widgetStyle: React.CSSProperties = {
    position: "fixed",
    background: widgetColor,
    ...(resolvedHorizontalAnchor === "left"
      ? { left: horizontalDistance }
      : { right: horizontalDistance }),
    ...(resolvedVerticalAnchor === "top"
      ? { top: verticalDistance }
      : { bottom: verticalDistance }),
  };

  return (
    <div
      className="select-none w-[31.25rem] h-[95vh] z-[9999] fixed flex flex-col items-center rounded-[0.75rem] transition-all duration-200 pointer-events-auto widgetContainer"
      style={!isMobile() ? widgetStyle : { background: widgetColor }}
    >
      <div className="relative w-[100%] h-[95vh] flex flex-col items-center widgetInnerContainer">
        <div
          className="w-[100%] h-[95vh] flex flex-col items-center widgetProfileCustomizeContainer"
          style={isMobile() ? { height: `calc(var(--vh, 1vh) * 100)` } : {}}
        >
          <div className="w-[96%] h-[8vh] mt-[0.63rem] mb-[0.63rem] flex items-center justify-between widgetNavContainer">
            <div className="flex items-center gap-[0.94rem]">
              <div className="w-[1.83606rem] h-[1.3125rem]">
                <div
                  style={{
                    backgroundImage: `url(${"/widgetIcon/accessbilityIcon.svg"})`,
                  }}
                  className="w-[100%] h-[100%] bg-no-repeat bg-center bg-contain"
                />
              </div>
              <div className="font-[700] leading-[1.375rem] text-primary-background accessbilityMenuTitle">
                {t("Accessibillity Menu")}
                {!isMobile() && <>(Ctrl + U)</>}
              </div>
            </div>

            <div className="flex items-center gap-[0.94rem]">
              <button
                className="w-[1.75rem] h-[1.75rem] flex items-center justify-center aspect-square rounded-[0.3125rem] cursor-pointer"
                onClick={handleLanguageSelection}
              >
                <div
                  style={{
                    backgroundImage: `url(${
                      language?.url ||
                      language?.image ||
                      "/language/englishUKIcon.svg"
                    })`,
                  }}
                  className="w-[100%] h-[100%] bg-no-repeat bg-center bg-contain"
                />
              </button>

              <div className="w-[1.75rem] h-[1.75rem] flex items-center justify-center aspect-square rounded-[0.3125rem] cursor-pointer">
                <a
                  href={
                    widgetSettings?.advanced?.accessibilityStatement
                      ?.statementLink
                  }
                  target="_blank"
                  rel="noreferrer"
                  style={{
                    backgroundImage: `url(${"/feedback/accessbility_doll.svg"})`,
                  }}
                  className="w-[100%] h-[100%] bg-no-repeat bg-center bg-contain"
                />
              </div>

              <button
                onClick={() => {
                  toggle();
                }}
                className="w-[1.75rem] h-[1.75rem] flex items-center justify-center p-[0.25rem] aspect-square bg-primary-background rounded-[0.3125rem] cursor-pointer"
              >
                <div
                  style={{
                    backgroundImage: `url(${"/widgetIcon/widgetCloseIcon.svg"})`,
                  }}
                  className="w-[100%] h-[100%] bg-no-repeat bg-center bg-contain"
                />
              </button>
            </div>
          </div>

          {isFeedbackOpen ? (
            <Feedback color={widgetColor} />
          ) : (
            <>
              <div className="w-[96%] h-[90vh] bg-primary-background rounded-[0.6875rem] flex flex-col pt-[0.94rem] pl-[0.88rem] pr-[0.88rem] keyTabsContainer">
                {widgetSettings?.advanced?.profilesEnabled === true && (
                  <div className="w-[100%] h-[2.9375rem] p-[0.0625rem] shrink-0 flex items-center justify-center rounded-[0.5rem] bg-toggle-background">
                    {data.keyTabs.map((item, index) => (
                      <button
                        key={index}
                        className={`text-transparent w-[50%] h-[100%] bg-primary-background py-[0.71875rem] px-[2.0625rem] shrink-0 flex items-center justify-center rounded-[0.5rem] cursor-pointer transition-all duration-300 ease-in-out ${
                          selectedTab === item.title
                            ? "selectedTab"
                            : "nonSelectedTab"
                        }`}
                        onClick={() => {
                          handleSelectedTab(item.title);
                        }}
                      >
                        <div
                          className={`${
                            selectedTab === item.title
                              ? "selectedTabTitle transition-all duration-300 ease-in-out"
                              : "nonSelectedTabTitle transition-all duration-300 ease-in-out hover:text-voice-help-title-hover"
                          }`}
                          title={t(item.title)}
                          style={
                            selectedTab === item.title
                              ? typeof widgetColor === "string" &&
                                widgetColor.includes("linear-gradient")
                                ? { background: widgetColor }
                                : { color: widgetColor }
                              : undefined
                          }
                        >
                          {t(item.title).length > 21
                            ? `${t(item.title).slice(0, 21)}…`
                            : t(item.title)}
                        </div>
                      </button>
                    ))}
                  </div>
                )}

                {selectedTab === data.keyTabs[0].title &&
                  widgetSettings?.advanced?.profilesEnabled === true && (
                    <div className="flex flex-col pb-[1rem]">
                      <AccessibilityProfile
                        color={widgetColor}
                        setSelectedTab={setSelectedTab}
                        setSelectedCategory={setSelectedCategory}
                        setHiglightId={setHiglightId}
                      />
                    </div>
                  )}

                {selectedTab === data.keyTabs[1].title && (
                  <div className="flex flex-col pb-[1rem]">
                    <AccessibilityCustomize
                      color={widgetColor}
                      selectedCategory={selectedCategory}
                      higlightId={higlightId}
                    />
                  </div>
                )}
              </div>
            </>
          )}

          {!isFeedbackOpen && (
            <div className="w-[100%] h-[8vh] mt-[0.63rem] mb-[0.63rem] relative flex items-center justify-between gap-[0.62rem] pl-[0.65rem] pr-[0.65rem]">
              {data.footerTabs.map((item, index) => (
                <button
                  key={index}
                  ref={(el) => {
                    buttonRefs.current[index] = el;
                  }}
                  onFocus={() => {
                    setTimeout(() => {
                      buttonRefs.current[index]?.blur();
                    }, 800);
                  }}
                  className="footerButton text-text-black text-nowrap focus:outline-none focus:ring-1 focus:ring-[#3B4395] focus:bg-[#bcbfd5]"
                  onClick={() => handleFooter(item.title)}
                  title={t(item.title)}
                >
                  <div className="truncate text-center max-w-[100px] md:max-w-[250px]">
                    {t(item.title)}
                  </div>

                  {item.title === "Reset Settings" && keyboardStatus && (
                    <button
                      style={{
                        backgroundImage: `url(${"/tooltip/infoIcon.svg"})`,
                      }}
                      className="w-[1.25rem] h-[1.25rem] absolute right-[5%] bg-no-repeat bg-center bg-contain rounded-[100%]"
                      onClick={(e) => {
                        e.stopPropagation();
                        setIsTooltipOpen(!isTooltipOpen);
                      }}
                    />
                  )}
                </button>
              ))}

              {isTooltipOpen && keyboardStatus && (
                <div className="absolute flex items-center justify-end pointer-events-none top-[-8rem] right-[4%] left-0 bottom-0">
                  <div className="bg-black rounded-md p-[1rem] drop-shadow-tooltip-shadow toolTipReset w-[35%]">
                    <div className="text-white text-center">
                      {t("CTRL + ALT + R")}
                    </div>
                  </div>
                </div>
              )}
            </div>
          )}

          <div
            className={`w-[100%] h-[7vh] bg-primary-background flex items-center justify-center gap-[0.56rem] poweredByContainer ${
              isLanguageOpen ? "bg-language-background" : ""
            }`}
          >
            <div className="text-primary font-normal leading-[1.125rem] text-text-black">
              {t("Powered By")}
            </div>
            <div className="w-[5.57919rem] h-[0.8125rem]">
              <a
                href="https://www.incluway.de/"
                target="_blank"
                rel="noreferrer"
                className="block w-[100%] h-[100%]"
                onClick={(e) => {
                  e.stopPropagation();
                }}
              >
                <div
                  style={{
                    backgroundImage: `url(${"/innerWidget/incluwayLogo.svg"})`,
                  }}
                  className="w-[100%] h-[100%] bg-no-repeat bg-center bg-contain"
                />
              </a>
            </div>
          </div>
        </div>
      </div>

      {isLanguageOpen && <Language isLanguageOpen={setIsLanguageOpen} />}
      {isCerticationOpen && <Certification />}
      {isResetOpen && <ResetSuccess color={widgetColor} />}
      {sample && <DictionaryActiveModal />}
    </div>
  );
}

export default Widget;
